import React, {Component} from 'react';
// import onClickOutside from 'react-onclickoutside';
import UncontrolledDropdown from "reactstrap/lib/UncontrolledDropdown";
import DropdownToggle from "reactstrap/lib/DropdownToggle";
import DropdownMenu from "reactstrap/lib/DropdownMenu";
import DropdownItem from "reactstrap/lib/DropdownItem";
import PropTypes from 'prop-types';

class Dropdown extends Component {
    state = {
        visible: false
    }

    /*
    handleClickOutside = (evt) => {
        this.setState({ visible: false });
    };
     */
    onSelected = (opt) => () => {
        this.props.onSelected(opt);
        this.setState({visible: false});
    }

    toggleVisible = () => {
        this.setState({visible: !this.state.visible});
    }

    render() {
        const {opts} = this.props;
        const selected = this.props.selected || opts[0];
        return (
            <UncontrolledDropdown>
                <DropdownToggle caret className={"text-muted btn-sm py-0"} color={"transparent"}>
                    <span>{selected.label}</span>
                </DropdownToggle>
                <DropdownMenu>
                    {
                        opts.map((item) => <DropdownItem key={String(item.value)}
                                                         onClick={this.onSelected(item)}>{item.label}</DropdownItem>)
                    }
                </DropdownMenu>
            </UncontrolledDropdown>
        )
        /*
        return (
            <div style={{ position: 'relative' }}>
                <span className={'py-2'} onClick={this.toggleVisible}>{selected.label} <CaretDown  /></span>
                {
                    this.state.visible &&
                    <div style={{ position: 'absolute', top: 36, right: 0, zIndex: 400 }}>
                        <div className={'list-group shadow'}>
                            {
                                opts.map((item) => <button className={'list-group-item list-group-item-action'} onClick={this.onSelected(item)}>{item.label}</button>)
                            }
                        </div>

                    </div>
                }
            </div>
        );
         */
    }
}

Dropdown.propTypes = {
    opts: PropTypes.array.isRequired,
    selected: PropTypes.any.isRequired,
    onSelected: PropTypes.func.isRequired,
}

export default Dropdown;
